import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
// Import JSON translation files
import enTranslation from './locales/en.json';
import thTranslation from './locales/th.json';

// Translation resources
const resources = {
  en: { translation: enTranslation },
  th: { translation: thTranslation }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'th', // Default language (Thai)
    fallbackLng: 'en', // Fallback language

    interpolation: {
      escapeValue: false // React already escapes values
    },

    // Namespace settings
    defaultNS: 'translation',
    ns: ['translation'],

    // Development settings
    debug: process.env.NODE_ENV === 'development',

    // React specific settings
    react: {
      useSuspense: false // Disable suspense for SSR compatibility
    }
  });

export default i18n;
